import { cx } from '@linaria/core';
import { Dropdown } from '@ui/kit';
import { hr, footer, dropdown } from './dropdown.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SolidDropdown(props) {
  return /*#__PURE__*/jsx(Dropdown, {
    ...props,
    className: cx(dropdown, props.className),
    restoreFocus: {
      preventScroll: true
    },
    offsetPx: 10,
    placement: "bottom-end",
    children: /*#__PURE__*/jsx(SolidDropdownContent, {
      ...props
    })
  });
}
function SolidDropdownContent(props) {
  const hasChildren = props.children && !Array.isArray(props.children) || Array.isArray(props.children) && props.children.length > 0;
  return /*#__PURE__*/jsxs("div", {
    children: [hasChildren && /*#__PURE__*/jsx("ul", {
      children: props.children
    }), props.footer && /*#__PURE__*/jsxs("div", {
      className: cx(footer, hasChildren && "hasChildren"),
      children: [hasChildren && /*#__PURE__*/jsx("hr", {
        className: hr
      }), props.footer]
    })]
  });
}

export { SolidDropdown, SolidDropdownContent };
//# sourceMappingURL=dropdown.js.map
